// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TypesPriority = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Highest: 'highest',
} as const;
export type TypesPriority = (typeof TypesPriority)[keyof typeof TypesPriority];

export function instanceOfTypesPriority(value: any): boolean {
  for (const key in TypesPriority) {
    if (Object.prototype.hasOwnProperty.call(TypesPriority, key)) {
      if (TypesPriority[key as keyof typeof TypesPriority] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TypesPriorityFromJSON(json: any): TypesPriority {
  return TypesPriorityFromJSONTyped(json, false);
}

export function TypesPriorityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesPriority {
  return json as TypesPriority;
}

export function TypesPriorityToJSON(value?: TypesPriority | null): any {
  return value as any;
}

export function TypesPriorityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TypesPriority {
  return value as TypesPriority;
}
